export enum DirectivePrefix {
    NG_DIRECTIVE_PREFIX = "ng",
    CUSTOM_DIRECTIVE_PREFIX = "qpv"
}